import { Logo } from "./Logo";
import { NAV_LINKS } from "./data";

export const Footer = () => {
  return (
    <footer className="bg-[#00163d] border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div className="max-w-sm">
            <Logo light className="h-14" />
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              PrimeLane Logistics LLC provides freight brokerage, consolidation, warehouse coordination, and supply chain
              support for businesses moving freight across the United States and beyond.
            </p>
          </div>
          <div className="md:justify-self-end">
            <div className="flex flex-wrap gap-x-8 gap-y-3">
              {NAV_LINKS.map((l) => (
                <a key={l.href} href={l.href} className="text-sm text-slate-300 hover:text-[#FE6A04] transition-colors">
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} PrimeLane Logistics LLC. All rights reserved.</p>
          <p className="text-xs text-slate-500">Freight brokerage • Miami consolidation • FTL • LTL • Expedited • Air &amp; Ocean coordination.</p>
        </div>
      </div>
    </footer>
  );
};
